import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
    static targets = ["file", "form", "button", "container"]
    static values = { rbfClaimTemplateId: Number, mode: String }

    connect() {
        if (this.hasContainerTarget) {
            this.updateGenerateButtonState();
            this.containerTarget.addEventListener("change", () => {
                this.updateGenerateButtonState();
            });
        }

        if (this.hasFormTarget && this.hasButtonTarget) {
            this.formTarget.addEventListener("submit", () => {
                this.buttonTarget.textContent = "Generating file...";
                this.buttonTarget.disabled = true;
            });
        }
    }

    fetchDynamicFormFields(event) {
        if (!this.hasRbfClaimTemplateIdValue) return;

        const id = this.rbfClaimTemplateIdValue;

        // Determine if this is for verification or sampling based on the form context
        const isVerification = this.formTarget.id === "verification_form" || this.formTarget.id === "verification_upload_form";
        const turboFrameId = isVerification ?
            (this.formTarget.id === "verification_upload_form" ? "verification_upload_dynamic_form_fields_list" : "verification_dynamic_form_fields_list") :
            "dynamic_form_fields_list";

        const mode = this.hasModeValue ? this.modeValue : "sampling";

        fetch(`/external_claim_verification/dynamic_form_fields?rbf_claim_template_id=${id}&mode=${mode}`, {
            headers: { Accept: "text/vnd.turbo-stream.html" }
        })
            .then(response => response.text())
            .then(html => Turbo.renderStreamMessage(html));
    }

    toggleIncludeSampled(event) {
        if (!this.hasRbfClaimTemplateIdValue) return;
        const includeSampled = event.target.checked;
        const id = this.rbfClaimTemplateIdValue;

        // Determine if this is for verification or sampling based on the form context
        const isVerification = this.formTarget.id === "verification_form" || this.formTarget.id === "verification_upload_form";
        const turboFrameId = isVerification ? "verification_claim_list" : "sampling_claim_list";
        const mode = isVerification ? "verification" : "sampling";

        fetch(`/external_claim_verification/claims?rbf_claim_template_id=${id}&include_sampled=${includeSampled}&mode=${mode}`, {
            headers: {
                Accept: "text/vnd.turbo-stream.html",
                "Turbo-Frame": turboFrameId
            }
        })
            .then(response => response.text())
            .then(html => {
                const frame = document.getElementById(turboFrameId);
                if (frame) frame.innerHTML = html;
            });
    }

    updateGenerateButtonState(anyChecked = null) {
        if (anyChecked === null) {
            if (!this.hasContainerTarget) return;
            anyChecked = !!this.containerTarget.querySelector("input[type=checkbox]:checked");
        }
        this.toggleButtonState(anyChecked);
    }

    fileSelected() {
        if (!this.hasFileTarget) return;
        const hasFile = this.fileTarget.files.length > 0;
        this.toggleButtonState(hasFile);
    }

    toggleButtonState(enabled) {
        if (!this.hasButtonTarget) return;

        const btn = this.buttonTarget;
        btn.toggleAttribute("disabled", !enabled);

        const toggles = [
            ["bg-grey-1", !enabled],
            ["text-grey-4", !enabled],
            ["cursor-not-allowed", !enabled],
            ["bg-tealLight", enabled],
            ["text-white", enabled],
            ["cursor-pointer", enabled],
        ];

        toggles.forEach(([cls, on]) => btn.classList.toggle(cls, on));
    }
}
